import Endpoints from 'constants/Endpoints';
import Tr from 'translations/Translations';
import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import getOnlyValidMomentObjectOrDefault from "libs/getOnlyValidMomentObjectOrDefault";
import RepoFolderTypes from "constants/RepoFolderTypes";
import downloadFileWithPreloadUrl from "libs/downloadFileWithPreloadUrl";
import isResponseValid from "../libs/isResponseValid";

const VISIBILITY_TYPES_RESOURCE_ID = "repoVisibilityTypes";
const FOLDER_LIST_RESOURCE_ID = "folderList";
const REPO_EDITABLE_RESOURCE_ID = "repoEditable";
const REPO_CONTRACTORS_RESOURCE_ID = "repoAllContractors";

const __get = async (url, resourcesName) => {
    try {
        let res = await RestRequestGET(url)
        reduxStore.dispatch(setResource(resourcesName, res))
    } catch (error) {
    }
}

const getList = async (demandId) => {
    await __get(Endpoints.REPO(demandId), FOLDER_LIST_RESOURCE_ID)
}

const getVisibilityTypes = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.REPO_VISIBILITY_TYPES(demandId));
    const types = {};
    Object.keys(resp).forEach(x => types[x] = Tr(`repo.visibility.${x}`));
    reduxStore.dispatch(setResource(VISIBILITY_TYPES_RESOURCE_ID, types));
}

const getContractors = async (demandId) => {
    const res = await RestRequestGET(Endpoints.REPO_CONTRACTORS(demandId));
    reduxStore.dispatch(setResource(REPO_CONTRACTORS_RESOURCE_ID, res.result));
    return res.result;
}
const addFolder = async (demandId, values) => {
    const {resources} = reduxStore.getState();
    const {folderList} = resources

    let res = await RestRequestPOST(Endpoints.REPO(demandId), values);

    const insertIndex = folderList.findIndex((el) => !(el.type.startsWith('x')));
    let temp = [...folderList];
    temp.splice(insertIndex < 0 ? 0 : insertIndex, 0, res);
    reduxStore.dispatch(setResource(FOLDER_LIST_RESOURCE_ID, temp))

}

const updateDescription = async (demandId, {fileId, folderId}, description) => {
    const resp = await RestRequestPUT(Endpoints.REPO_FILE_UPDATE_DESCRIPTION(demandId, fileId), {description});
    updateFileRowInStore(resp, folderId);
}

const updateFileRowInStore = (resp, folderId) => {

    const {resources} = reduxStore.getState();
    const {folderList} = resources;
    const folderIndex = folderList.findIndex((x) => {
        return x.identity === folderId;
    })
    const folder = folderList[folderIndex];
    const fileIndex = folder.files.findIndex(f => f.identity === resp.identity)
    folder.files[fileIndex] = resp;
    let newFolderList = [...folderList]

    reduxStore.dispatch(setResource(FOLDER_LIST_RESOURCE_ID, newFolderList))
}

const changeFileVisibility = async (demandId, folderId, fileId, values) => {
    const visibilityEndDate = getOnlyValidMomentObjectOrDefault(values.visibilityEndDate, null);
    const data = {
        visibility: values.visibility,
        visibilityEndDate: visibilityEndDate ? visibilityEndDate.format() : null,
        contractors: values.contractors
    }
    try {
        const respFolder = await RestRequestPUT(Endpoints.REPO_FILE_VISIBILITY(demandId, fileId), data);
        await _updateFolderInStore(demandId, respFolder, false);
    } catch (error) {
    }

}

const changeFolderFilesVisibility = async (demandId, folderId, values) => {
    const visibilityEndDate = getOnlyValidMomentObjectOrDefault(values.visibilityEndDate, null);
    const data = {
        visibility: values.visibility,
        visibilityEndDate: visibilityEndDate ? visibilityEndDate.format() : null,
        contractors: values.contractors
    }

    try {
        let res = await RestRequestPUT(Endpoints.REPO_FILES_VISIBILITY(demandId, folderId), data);
        await _updateFolderInStore(demandId, res, false);
    } catch (error) {
    }
}

const updateFolderName = async (demandId, folderId, name) => {
    try {
        let respFolder = await RestRequestPUT(Endpoints.REPO_FOLDER(demandId, folderId), {name})
        await _updateFolderInStore(demandId, respFolder, false);

    } catch (error) {
    }
}
const updateFolderDescription = async (demandId, folderId, description) => {
    try {
        let respFolder = await RestRequestPUT(Endpoints.REPO_FOLDER(demandId, folderId), {description})
        await _updateFolderInStore(demandId, respFolder, false);

    } catch (error) {
    }
}

const addFiles = async (demandId, folderId, values) => {
    let data = {
        "list": [...values],
    }
    try {
        let respFolder = await RestRequestPOST(Endpoints.REPO_FOLDER(demandId, folderId), data)
        await _updateFolderInStore(demandId, respFolder, false);
    } catch (error) {
    }
}

const refreshFolder = async (demandId, folderId) => {
    try {
        let respFolder = await RestRequestGET(Endpoints.REPO_FOLDER(demandId, folderId))
        await _updateFolderInStore(demandId, respFolder, false);
    } catch (error) {
    }
}

const _updateFolderInStore = async (demandId, respFolder, updateTrash) => {
    const {resources} = reduxStore.getState();
    const {folderList} = resources;

    const newFolderList = folderList.map((el) => {
        if (el.identity === respFolder.identity) {
            return respFolder
        }
        return el;
    });
    if(updateTrash) {
        await _doUpdateTrash(demandId, newFolderList, respFolder.identity)
    }
    reduxStore.dispatch(setResource(FOLDER_LIST_RESOURCE_ID, newFolderList))
}

const updateTrash = async (demandId) => {
    const {resources} = reduxStore.getState();
    const {folderList} = resources;
    const modified = await _doUpdateTrash(demandId, folderList);
    if(modified) {
        reduxStore.dispatch(setResource(FOLDER_LIST_RESOURCE_ID, [...folderList]))
    }

}

const _doUpdateTrash = async (demandId, newFolderList, workingFolderIdentity) => {
    if (updateTrash) {
        let trashIndex = newFolderList.findIndex(el =>  el.identity !== workingFolderIdentity && el.type === RepoFolderTypes.Z_TRASH);
        if (trashIndex > -1) {
            newFolderList[trashIndex] = await RestRequestGET(Endpoints.REPO_FOLDER(demandId, newFolderList[trashIndex].identity));
            return true;
        }
    }
    return false;
}



const deleteItem = async (demandId, fileId) => {
    try {
        const respFolder = await RestRequestDELETE(Endpoints.REPO_FILE(demandId, fileId));
        await _updateFolderInStore(demandId, respFolder, true);
    } catch (error) {
        console.error(error);
    }
}

const deleteFolder = async (demandId, folderId) => {
    const {resources} = reduxStore.getState();
    const {folderList} = resources;
    try {
        const res = await RestRequestDELETE(Endpoints.REPO_FOLDER(demandId, folderId));
        if (res.success) {

            let newFolderList = folderList.filter(x => x.identity !== folderId);

            const trashIndex = newFolderList.findIndex(x => x.type === RepoFolderTypes.Z_TRASH && x.identity !== folderId);

            if (trashIndex > -1) {
                newFolderList[trashIndex] = await RestRequestGET(Endpoints.REPO_FOLDER(demandId, newFolderList[trashIndex].identity));
            }

            reduxStore.dispatch(setResource(FOLDER_LIST_RESOURCE_ID, newFolderList))
        }
    } catch (error) {
    }
}


const deleteAll = async (demandId, folderId) => {
    try {
        const respFolder = await RestRequestDELETE(Endpoints.REPO_DELETE_ALL_FOLDER_FILES(demandId, folderId))
        await _updateFolderInStore(demandId, respFolder, true);
    } catch (error) {
    }
}

const downloadAll = async (demandId, folderId) => {
    try {
        await RestRequestBLOB(Endpoints.REPO_DOWNLOAD_ALL(demandId, folderId));
    } catch (error) {
    }
}

const getDownloadHistory = async (demandId, fileId, pagination) => {

    const params = {
        ...pagination
    }

    const url = Endpoints.REPO_FILE_DOWNLOAD_HISTORY(demandId, fileId);
    try {
        return await RestRequestGET(url, {params});
    } catch (error) {
    }
}

const isRepoEditable = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.REPO_EDITABLE(demandId));
    reduxStore.dispatch(setResource(REPO_EDITABLE_RESOURCE_ID, resp));
}

const clearResources = (id) => {
    reduxStore.dispatch(clearResource(id));
}

const getDownloadFile = async (demandId, fileId, openInBrowser) => {
    await downloadFileWithPreloadUrl(Endpoints.REPO_FILE_GET_DOWNLOAD_URL(demandId, fileId, openInBrowser), openInBrowser);
}

const shareRepo = async (demandId, fileId, system) => {
    const resp = await RestRequestPOST(Endpoints.REPO_FILE_SHARE(demandId, fileId), {system});
    try {
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return true;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
    return false;
}

const loadLastShareHistory = async (demandId, fileId) => {
    return await RestRequestGET(Endpoints.REPO_FILE_SHARE_HISTORY_LAST(demandId, fileId));
}

const loadShareHistory = async (demandId, fileId, system) => {
    return await RestRequestGET(Endpoints.REPO_FILE_SHARE_HISTORY(demandId, fileId, system));
}

const shareRepoFolder = async (demandId, folderId, system) => {
    const resp = await RestRequestPOST(Endpoints.REPO_FOLDER_SHARE(demandId, folderId), {system});
    try {
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return true;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
    return false;
}

const buildIdentity = (fileId, folderId) => ({fileId, folderId});

export default {
    addFolder,
    getList,
    addFiles,
    refreshFolder,
    deleteItem,
    deleteAll,
    deleteFolder,
    downloadAll,
    updateFolderName,
    updateFolderDescription,
    getDownloadHistory,
    getVisibilityTypes,
    getContractors,
    changeFileVisibility,
    changeFolderFilesVisibility,
    updateDescription,
    updateFileRowInStore,
    clearResources,
    getDownloadFile,
    shareRepo,
    loadLastShareHistory,
    loadShareHistory,
    shareRepoFolder,
    isRepoEditable,
    buildIdentity,
    updateTrash,
    FOLDER_LIST_RESOURCE_ID,
    VISIBILITY_TYPES_RESOURCE_ID,
    REPO_EDITABLE_RESOURCE_ID,
    REPO_CONTRACTORS_RESOURCE_ID
}